import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => {
  return (
    <footer className="bg-muted border-t border-border mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Logo className="h-6 w-auto" />
              <span className="text-lg font-bold">Gordon Store</span>
            </div>
            <p className="text-sm text-muted-foreground">Todo lo que tu mascota necesita, con amor y calidad.</p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-semibold mb-4">Navegación</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/catalogo" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Catálogo
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Nosotros
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-semibold mb-4">Categorías</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/catalogo?category=food"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Alimentos
                </Link>
              </li>
              <li>
                <Link
                  to="/catalogo?category=toys"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Juguetes
                </Link>
              </li>
              <li>
                <Link
                  to="/catalogo?category=accessories"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Accesorios
                </Link>
              </li>
              <li>
                <Link
                  to="/catalogo?category=hygiene"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Higiene
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Mail className="h-4 w-4" />
                <span>docapetshopcr@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Phone className="h-4 w-4" />
                <span>+506 6449 8772</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4" />
                <span>San José, Costa Rica</span>
              </li>
            </ul>
            <div className="flex items-center space-x-4 mt-4">
              <a
                href="https://www.facebook.com/doca.cr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/gordon_storecr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border text-center text-sm text-muted-foreground">
          <p>© 2025 Gordon Store. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
